import { Drawer, Typography } from 'antd';
import Catalogue from '../../../Catalogue';

const { Title } = Typography;


const AddProducts = ({ open, onClose, isDrawer }) => {
  return (
    <Drawer
      title={
        <Title level={3} className='page-title'>
          Product Catalogue
        </Title>
      }
      classNames={{
        body: 'p-0'
      }}
      open={open}
      onClose={onClose}
      placement="bottom"
      height="100dvh"
      width="100vw"
      styles={{
        wrapper: {
          borderTopLeftRadius: '0',
          borderTopRightRadius: '0',
          overflow: 'auto',
        },
      }}
    >
      <Catalogue isDrawer={isDrawer} />
    </Drawer>
  );
};

export default AddProducts;
